// Age Verification API helpers
import apiClient from './client';

/**
 * Start the age verification process with Stripe Identity
 * @returns {Promise<{verification_url: string, session_id: string, status: string}>}
 */
export async function startAgeVerification() {
  const res = await apiClient.post('/verify/age/start', {});
  return res.data;
}

/**
 * Get current age verification status
 * @returns {Promise<{is_age_verified: boolean, identity_verification_status: string, age_verified_at: string, provider: string}>}
 */
export async function fetchAgeVerificationStatus() {
  const res = await apiClient.get('/verify/age/status');
  return res.data;
}
